module.exports = __webpack_public_path__ + "static/media/light-scallops.9b884c27.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/light-scallops.svg
// module id = 187
// module chunks = 0